const HTTP_REQUEST_KEYS = {
    SHIPPING_FEES: 'shipping_fees',
    PRODUCT_BATCH_STOCKS: 'product_batch_stocks',
    CART_MIXED_STOCKS_COMPUTE: 'cart_mixed_stocks_compute',
    PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE: 'product_mixed_stocks_fitting_options_compute',
    TYRE_FILTER_OPTIONS: 'tyre_filter_options',
    MOTO_TYRE_FILTER_OPTIONS: 'moto_tyre_filter_options',
    CART_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE: 'cart_mixed_stocks_shipping_options_compute',
};

export default HTTP_REQUEST_KEYS;
